import React, {useContext} from 'react';
import {Button, Dialog, SideSheet} from '@bonprix/design-system';
import {useDispatch, useSelector} from 'react-redux';
import {closeFilter, selectFilterStatus} from '../../FilterSlice.jsx';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import {yieldToMain} from '../../ArticleOverviewHelper.js';
import SideSheetLoader from './SideSheetLoader.jsx';
import {loadOnAccordeon, selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {setFilterAjaxCall} from '../../AjaxCallSlice.jsx';
import {Constants} from '../../view-constants.js';
import {useTrinity} from '../../hooks/use-trinity.js';
import {useChangeFilters} from '../../hooks/use-change-filters.js';

function FilterSideSheet({hits, filterSubmit, children}) {
    const {texts, currentSearchParams} = useContext(articleOverviewStaticContext);
    const {sendClickBasic} = useTrinity();

    const filterOpened = useSelector(selectFilterStatus).opened;
    const contentLoading = useSelector(selectLoadingbarStatus).status;
    const filterLoading = useSelector(selectFilterLoadingbarStatus).status;

    const dispatch = useDispatch();
    const {resetFilters} = useChangeFilters();

    const dispatchCloseSideSheet = () => {
        dispatch(setFilterAjaxCall(['', false]));
        dispatch(closeFilter());
    };
    const closeSideSheet = () => {
        dispatchCloseSideSheet();
        sendClickBasic('close_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    const resetFilterClick = () => {
        // Check if there are any filters or ordering currently applied
        const hasFilters = Array.from(currentSearchParams.current.keys()).some(
            key => key.startsWith(Constants.FILTER_PARAM_PREFIX)
        );
        const hasOrdering = currentSearchParams.current.has(Constants.SEARCH_PARAMS_ORDERING);
        
        // If no filters or ordering to reset, just close the sidesheet
        if (!hasFilters && !hasOrdering) {
            dispatchCloseSideSheet();
            return;
        }
        
        // Trigger loading and reset filters
        yieldToMain(() => dispatch(loadOnAccordeon()));
        resetFilters(true);
        sendClickBasic('reset_filter', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    const submitButtonClick = () => {
        yieldToMain(() => {
            dispatch(loadOnAccordeon());
        });
        filterSubmit();
    };

    return (
        <SideSheet isOpen={filterOpened} onClose={closeSideSheet} zIndex={1000}>
            <SideSheet.Title>{texts.filter_title}</SideSheet.Title>
            <SideSheet.Content>
                {children}
                <SideSheetLoader />
            </SideSheet.Content>
            <SideSheet.ButtonSection>
                <Button
                    onClick={resetFilterClick}
                    variant="secondary"
                    size="large"
                    disabled={filterLoading}
                >
                    {texts.filter_reset_sidesheet}
                </Button>
                <Button
                    onClick={submitButtonClick}
                    size="large"
                    loading={contentLoading}
                    disabled={filterLoading || hits === 0}
                >
                    {hits === 1
                        ? `${hits} ${texts.filter_result}`
                        : `${hits} ${texts.filter_results}`}
                </Button>
            </SideSheet.ButtonSection>
        </SideSheet>
    );
}

export default React.memo(FilterSideSheet);
